// import {
//     Drawer,
//     DrawerBody,
//     DrawerContent,
//     DrawerFooter,
//     DrawerHeader,
//     DrawerOverlay,
//     DrawerCloseButton,
//     FormLabel
// } from "@chakra-ui/react";
// import { useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import ProgressBar from "../../../utils/progressBar/ProgressBar";
// import { addSolarInverter,updateSolarInverter } from "../../../redux/api/solarInverterApi/SolarInverterApi"; 
// export function SolarInverterForm(props) {

//     const { dataToEdit, setIsUpdateMode, isUpdateMode, solarInverterId } = props;
//     const [showProgressBar, setShowProgressBar] = useState(false);
//     const closeDrawer = props.closeSolarInverter;
//     const initialFormData = {
//         inverterName: "",
//         inverterDescription: ""
//     }
//     const [formData, setFormData] = useState(initialFormData);

//     // UpdateMode Use-effect
//     useEffect(() => {
//         if (isUpdateMode && dataToEdit) {
//             setFormData((prev) => ({
//                 ...prev, ...props.dataToEdit,
//             }))
//         }
//     }, [isUpdateMode, dataToEdit]);

//     const handleOnClose = () => {
//         closeDrawer()
//         setFormData(initialFormData);
//     }

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prevState => ({
//             ...prevState,
//             [name]: value
//         }));
//     }

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         console.log("submit", formData)
//         setShowProgressBar(true)
//         addSolarInverter({...formData, createdBy: localStorage.getItem("email")})
//             .then((res) => {
//                 if(res.data.success) {
//                     toast.success("Solar Inverter added successful")
//                 } 
//             })
//             .catch((error) => {
//                 console.error("Error adding solar inverter:", error);
//                 toast.error("Error adding solar inverter")
//             })      
                   
//         // Simulate API call delay
//         setTimeout(() => {
//             setShowProgressBar(false);
//             closeDrawer();
//         }, 1000);
//     }

//     const handleUpdate = (e) => {
//         e.preventDefault();
//         console.log("update", formData)
//         setShowProgressBar(true)
//         // Simulate API call delay
//         updateSolarInverter(formData.ROWID, formData)

//         .then((res) => {
//             if(res.data.success) {
//                 toast.success("Solar Inverter updated successful")
//             } 
//         })
//         .catch((error) => {
//             console.error("Error updating solar inverter:", error);
//             toast.error("Error updating solar inverter")
//         })
//         setTimeout(() => {
//             setShowProgressBar(false);
//             // closeDrawer();
//         }, 1000);
//     }

//     return (
//         <>
//             <Drawer isOpen={props.isSolarInverter} size='xl' onClose={handleOnClose}>
//                 <DrawerOverlay />
//                 <DrawerContent>
//                     <DrawerCloseButton />
//                     <DrawerHeader>Create Inverter</DrawerHeader>
//                     <DrawerBody>
//                         {showProgressBar && <ProgressBar colorScheme='pink' />}
//                         <form onSubmit={isUpdateMode ? handleUpdate : handleSubmit}>
//                             <div className='card'>
//                                 <div className='card-body'>
//                                     <div className='row '>
//                                         <legend style={{ fontSize: 'Large' }} className='sub-headers'>Inverter Information</legend>
//                                         <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
//                                             <div className='search-by-title'>
//                                                 <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Inverter Brand Name' name='inverterName' value={formData?.inverterName} onChange={handleChange} />
//                                             </div>
//                                             <FormLabel className="small-label ps-3">Inverter Brand Name<span style={{ color: 'red' }}>*</span></FormLabel>
//                                         </div>
//                                         <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
//                                             <div className='search-by-title'>
//                                                 <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Inverter Brand Description' name='inverterDescription' value={formData?.inverterDescription} onChange={handleChange} />
//                                             </div>
//                                             <FormLabel className="small-label ps-3">Inverter Brand Description</FormLabel>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </form>
//                     </DrawerBody>
//                     <center><DrawerFooter style={{ display: 'inline-block' }} >
//                         <div className='gap-3 d-flex'>
//                             <button variant='outline' mr={3} onClick={handleOnClose} className="cancel-button">
//                                 Cancel
//                             </button>
//                             <button className='create-button' onClick={(e) => { !isUpdateMode ? handleSubmit(e) : handleUpdate(e) }} >{isUpdateMode ? "Update" : "Submit"}</button>
//                         </div>
//                     </DrawerFooter></center>
//                 </DrawerContent>
//             </Drawer>
//         </>
//     )
// }


import {
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerCloseButton,
    FormLabel
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import ProgressBar from "../../../utils/progressBar/ProgressBar";
import { addSolarInverter, updateSolarInverter } from "../../../redux/api/solarInverterApi/SolarInverterApi"; 
import { addSolarInverterAction,updateSolarInverterAction } from "../../../redux/reduxSlice/SolarInverterSlice";

export function SolarInverterForm(props) {
    const dispatch = useDispatch(); // Add this hook
    const { dataToEdit, setIsUpdateMode, isUpdateMode, solarInverterId } = props;
    const [showProgressBar, setShowProgressBar] = useState(false);
    const closeDrawer = props.closeSolarInverter;
    
    const initialFormData = {
        inverterName: "",
        inverterDescription: ""
    }
    const [formData, setFormData] = useState(initialFormData);

    // UpdateMode Use-effect
    useEffect(() => {
        if (isUpdateMode && dataToEdit) {
            setFormData((prev) => ({
                ...prev, ...props.dataToEdit,
            }))
        }
    }, [isUpdateMode, dataToEdit]);

    const handleOnClose = () => {
        closeDrawer()
        setFormData(initialFormData);
        setIsUpdateMode(false); // Reset update mode when closing
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("submit", formData)
        setShowProgressBar(true)
        
        addSolarInverter({...formData, createdBy: localStorage.getItem("email")})
            .then((res) => {
                if(res.data.success) {
                    // Dispatch the action to update Redux store
                    console.log("res.data",res.data);
                    
                    dispatch(addSolarInverterAction({
                        formData: {...formData, createdBy: localStorage.getItem("email")},
                        ROWID: res.data.resp?.ROWID // Assuming API returns the new ID
                    }));
                    toast.success("Solar Inverter added successfully");
                    closeDrawer();
                    handleOnClose();
                } 
            })
            .catch((error) => {
                console.error("Error adding solar inverter:", error);
                toast.error("Error adding solar inverter");
            })      
            .finally(() => {
                setShowProgressBar(false);
            });
    }

    const handleUpdate = (e) => {
        e.preventDefault();
        console.log("update", formData)
        setShowProgressBar(true)
        
        updateSolarInverter(formData.ROWID, formData)
            .then((res) => {
                if(res.data.success) {
                    // Dispatch the action to update Redux store
                    dispatch(updateSolarInverterAction(formData));
                    toast.success("Solar Inverter updated successfully");
                    closeDrawer();
                    handleOnClose();
                } 
            })
            .catch((error) => {
                console.error("Error updating solar inverter:", error);
                toast.error("Error updating solar inverter");
            })
            .finally(() => {
                setShowProgressBar(false);
            });
    }

    return (
        <>
            <Drawer isOpen={props.isSolarInverter} size='xl' onClose={handleOnClose}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>{isUpdateMode ? "Update Inverter" : "Create Inverter"}</DrawerHeader>
                    <DrawerBody>
                        {showProgressBar && <ProgressBar colorScheme='pink' />}
                        <form onSubmit={isUpdateMode ? handleUpdate : handleSubmit}>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row '>
                                        <legend style={{ fontSize: 'Large' }} className='sub-headers'>Inverter Information</legend>
                                        <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                                            <div className='search-by-title'>
                                                <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Inverter Brand Name' name='inverterName' value={formData?.inverterName} onChange={handleChange} />
                                            </div>
                                            <FormLabel className="small-label ps-3">Inverter Brand Name<span style={{ color: 'red' }}>*</span></FormLabel>
                                        </div>
                                        <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                                            <div className='search-by-title'>
                                                <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Inverter Brand Description' name='inverterDescription' value={formData?.inverterDescription} onChange={handleChange} />
                                            </div>
                                            <FormLabel className="small-label ps-3">Inverter Brand Description</FormLabel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </DrawerBody>
                    <center><DrawerFooter style={{ display: 'inline-block' }} >
                        <div className='gap-3 d-flex'>
                            <button variant='outline' mr={3} onClick={handleOnClose} className="cancel-button">
                                Cancel
                            </button>
                            <button className='create-button' onClick={(e) => { !isUpdateMode ? handleSubmit(e) : handleUpdate(e) }} >{isUpdateMode ? "Update" : "Submit"}</button>
                        </div>
                    </DrawerFooter></center>
                </DrawerContent>
            </Drawer>
        </>
    )
}